import { ADMIN_API } from '../AdminAPI';
import { map } from 'rxjs';
import { getUnixTime } from 'date-fns';
import { convertUnixToDate } from '@golden/gdk-base';
export function createAnnouncementService(api) {
    return {
        getAnnouncement(id) {
            return api.fetch(ADMIN_API.GET_ANNOUNCEMENT, { config: { urlParams: { id } } }).pipe(map((res) => convertUnixToDate(res, 'begin_at', 'end_at', 'created_at', 'updated_at')));
        },
        getAnnouncementList(data) {
            return api.fetch(ADMIN_API.GET_ANNOUNCEMENT_LIST, { data }).pipe(map((res) => {
                return {
                    ...res,
                    data: res.data.map((item) => convertUnixToDate(item, 'begin_at', 'end_at', 'created_at', 'updated_at'))
                };
            }));
        },
        createAnnouncement(payload) {
            const data = {
                ...payload,
                begin_at: getUnixTime(payload.begin_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.POST_NEW_ANNOUNCEMENT, { data });
        },
        updateAnnouncement(payload, id) {
            const data = {
                ...payload,
                begin_at: getUnixTime(payload.begin_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.PUT_CHANGE_ANNOUNCEMENT, { data, config: { urlParams: { id } } });
        },
        deleteAnnouncement(id) {
            return api.fetch(ADMIN_API.DELETE_ANNOUNCEMENT, { config: { urlParams: { id } } });
        },
        toggleStatus(id, status) {
            return api.fetch(ADMIN_API.PUT_TOGGLE_ANNOUNCEMENT_STATUS, { data: { status }, config: { urlParams: { id } } });
        },
        getAgentAnnouncementList(data) {
            return api.fetch(ADMIN_API.GET_AGENT_ANNOUNCEMENT_LIST, { data }).pipe(map((res) => {
                return {
                    ...res,
                    data: res.data.map((item) => convertUnixToDate(item, 'begin_at', 'end_at', 'created_at', 'updated_at'))
                };
            }));
        },
        toggleAgentAnnouncementStatus(payload, staffAnnouncement) {
            const data = payload;
            return api.fetch(ADMIN_API.PUT_TOGGLE_AGENT_ANNOUNCEMENT_STATUS, { data, config: { urlParams: { staffAnnouncement } } });
        }
    };
}
//# sourceMappingURL=AnnouncementService.js.map